import { defaultSlides } from "../constants/pages";
import { OnboardingSlide } from "../types/onboarding";

export const getSlides = (): OnboardingSlide[] => {
  const config = import.meta.env.VITE_ONBOARDING_CONFIG;
  if (!config) return defaultSlides;

  try {
    const overrides = JSON.parse(config);
    if (!Array.isArray(overrides)) return defaultSlides;

    return defaultSlides.map((slide, index) => ({
      ...slide,
      ...overrides[index],
    }));
  } catch {
    return defaultSlides;
  }
};
